/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Company_NameInputs */

const vi_invoice_company_name = /** @type {(inputs: Invoice_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên công ty`)
};

/**

* @param {Invoice_Company_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_company_name = /** @type {((inputs?: Invoice_Company_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Company_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_company_name(inputs)
});